
import { defineComponent } from 'vue';
import FbxButton from '@/components/fbx-button.vue';
import SvgCamera from '@/components/Icons/SvgCamera.vue';

export default defineComponent({
    components: {
        FbxButton,
        SvgCamera,
    },
    emits: ['onContinueClicked'],
    data(): {
        countdown: number | null;
        intervalId: number | null;
    } {
        return {
            countdown: 5,
            intervalId: null,
        };
    },
    mounted() {
        this.initializeCountdown();
    },
    watch: {
        countdown: {
            handler() {
                if (this.countdown === null) {
                    clearInterval(this.intervalId as number);
                }
            },
        },
    },
    computed: {
        buttonText() {
            if (this.isContinueDisabled) {
                return `Read Above ${this.countdown}`;
            } else {
                return 'Proceed to QR Scan';
            }
        },
        isContinueDisabled() {
            return this.countdown !== null;
        },
    },
    methods: {
        initializeCountdown() {
            this.intervalId = setInterval(() => {
                if (this.countdown && this.countdown > 0) {
                    this.countdown--;
                } else {
                    this.countdown = null;
                }
            }, 1000);
        },
        onContinue() {
            this.$emit('onContinueClicked');
        },
    },
});
